import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config/config";
import "../css/flashsale.css";

function FlashSale() {

    const [sale, setSale] = useState(null);

    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    // =============================
    // LOAD FLASH SALE
    // =============================

    useEffect(() => {

        axios
            .get(`${API_URL}/flash-sale`)
            .then((res) => {

                setSale(res.data);

            })
            .catch(console.log);

    }, []);

    // =============================
    // COUNTDOWN
    // =============================

    useEffect(() => {

        if (!sale || !sale.end_date) return;

        const timer = setInterval(() => {

            const now = new Date().getTime();

            const end = new Date(sale.end_date).getTime();

            const distance = end - now;

            if (distance <= 0) {

                clearInterval(timer);

                setTimeLeft({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                });

                return;

            }

            setTimeLeft({

                days: Math.floor(distance / (1000 * 60 * 60 * 24)),

                hours: Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) /
                    (1000 * 60 * 60)
                ),

                minutes: Math.floor(
                    (distance % (1000 * 60 * 60)) /
                    (1000 * 60)
                ),

                seconds: Math.floor(
                    (distance % (1000 * 60)) /
                    1000
                )

            });

        }, 1000);

        return () => clearInterval(timer);

    }, [sale]);

    if (!sale || !sale.title)
        return null;

    return (

        <section className="flash-sale">

            {sale.image && (

                <img
                    src={`http://localhost:5000${sale.image}`}
                    alt={sale.title}
                    className="flash-sale-image"
                />

            )}

            <h2>{sale.title}</h2>

            <p>{sale.subtitle}</p>

            <h3>{sale.discount_text}</h3>

            <div className="countdown">

                <div>
                    <h3>{timeLeft.days}</h3>
                    <span>Days</span>
                </div>

                <div>
                    <h3>{timeLeft.hours}</h3>
                    <span>Hours</span>
                </div>

                <div>
                    <h3>{timeLeft.minutes}</h3>
                    <span>Minutes</span>
                </div>

                <div>
                    <h3>{timeLeft.seconds}</h3>
                    <span>Seconds</span>
                </div>

            </div>

            <a
                href={sale.button_link}
                className="shop-btn"
            >
                {sale.button_text}
            </a>

        </section>

    );

}

export default FlashSale;